module.exports = __webpack_public_path__ + "static/kincare-preview_1600.d443945c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/kincare/kincare-preview_1600.jpg
// module id = 468
// module chunks = 14357656358427